<template>
    <div class="page-content" id="profile-form">
        <Titlebar :incrustation="'fa-cogs'" :backPath="'/configurations/profiles'">
            <h1 v-html="pageTitle"></h1>
        </Titlebar>
        <div>
            <div class="row">
                <div class="col-4 col-xl-3">
                    <UiCard>
                        <div>
                            <FormWrapper>
                                <div
                                    class="alert alert-warning" 
                                    v-if="isEditRoute && $route.params.id && nbAppliedDevices < countDatis"
                                    v-html="$t('profile.warningVisibility',{count:(countDatis - nbAppliedDevices)})"
                                ></div>
                                <FormControl>
                                    <FormLabel>{{ $t('profile.form.icon') }}</FormLabel>
                                    <FormElement>
                                        <IconPicker :icon="profileDef.meta.icon" v-on:change="selectIcon"></IconPicker>
                                    </FormElement>
                                </FormControl>
                                <FormControl>
                                    <FormLabel>{{ $t('profile.form.label') }}</FormLabel>
                                    <UiInput 
                                        v-model="profileDef.meta.name" 
                                        name="label" 
                                        class="form-input"
                                        :isInvalid="$v.profileDef.meta.$invalid"
                                        :maxlength="64"
                                    />
                                    <FormError 
                                        v-if="$v.profileDef.meta.$invalid"
                                        v-text="$t('validation.required_field')"
                                    />
                                </FormControl>
                                <FormControl>
                                    <FormLabel>{{ $t('profile.form.description') }}</FormLabel>
                                    <UiTextarea v-model="profileDef.meta.description" name="description" />
                                </FormControl>
                                <FormControl>
                                    <FormLabel>{{$t('profile.form.set_as_default')}}</FormLabel>
                                    <FormElement>
                                        <div class="star-check" @click="handleDefaultStar" :title="$t('profile.form.set_as_default')">
                                            <input type="checkbox" v-model="profileDef.meta.default" />
                                            <i class="fa fa-star-o"></i>
                                            <i class="fa fa-star"></i>
                                            <div class="focus-block"></div>
                                        </div>
                                    </FormElement>
                                </FormControl>
                            </FormWrapper>
                            <ProfilesIndicator
                                :perf="perf"
                                :nbDatis="nbDatis"
                                :datisLicences="datisLicences"
                                class="mt-5"
                            />
                        </div>
                    </UiCard>
                </div>

                <div class="col-8 col-xl-9" >
                        <UiCard>

                        <!-- <div 
                            class="existing-profile" 
                            :class="{show:existingProfile}"
                            v-html="$t('profile.conflict',{profile:getExistingProfileName})"
                        ></div> -->

                        <div v-if="!profileDef.userCanUpdate" class="alert alert-warning mb-3">
                            {{ $t("profile.errors.user_has_no_dati_visibility") }}
                        </div>

                        <UiTabs
                            class="full-height mt-1"
                            style="display: grid; grid-template-rows: min-content 1fr;" 
                            content-class="full-height overflow-auto py-5"
                        >
                            <UiTab>

                                <template #title>
                                    {{ $t('profile.form.tab_workers') }} ({{ nbDatis }})
                                </template>

                                <div class="container">
                                    <FormWrapper>
                                        <FormControl v-for="(tag,key,indexTag) in servers" v-if="userHasOffer(tag.offers)" key="tag">
                                            <FormLabel>
                                                <span v-if="tag.type == 'relation' && key == 'telesurveilleur'" style="position: relative;">
                                                    <i class="fa fa-exclamation-triangle text-warning warning-beepiz-remote-monitoring" :class="{show:showWarningBeepizRemoteMonitoring}"></i>
                                                    <div class="tooltip left" style="width: 250px;top: -2px; left: 37px;">{{ $t('profile.tooltipWarningBeepizRemoteMonitoring') }}</div>
                                                </span>
                                                <span v-if="key == 'sms' || key == 'vocal'" style="position: relative;margin-left: 10px;">
                                                    <i class="fa fa-question-circle text-warning warning-beepiz-remote-monitoring show"></i>
                                                    <div class="tooltip left" style="width: 250px;top: -2px; left: 37px;">
                                                        {{ $t('profile.tooltipWarningPhoneNumber') }}
                                                        <template v-if="key == 'vocal'">
                                                            <br><br>
                                                            {{ $t('profile.tooltipCaller') }}
                                                        </template>
                                                    </div>
                                                </span>
                                                
                                            </FormLabel>
                                            <FormElement>
                                                <multiselect 
                                                    v-if="tag.type === 'array'"
                                                    :id="key"
                                                    class="form-input no-select"
                                                    v-model="tag.value"
                                                    :multiple="true"
                                                    :close-on-select="true"
                                                    :taggable="true"
                                                    placeholder=""
                                                    :options="[]"
                                                    @tag="addItem"
                                                    label="label"
                                                    track-by="key"
                                                    @blur="handleBlur"
                                                ></multiselect>

                                                <UiSwitch 
                                                    v-if="tag.type === 'boolean'" 
                                                    v-model="tag.value"
                                                    :true-value="1"
                                                    :false-value="0"
                                                />
                                                
                                                <select 
                                                    class="form-input col" 
                                                    v-if="tag.type === 'relation'" 
                                                    v-model="tag.value"
                                                >
                                                    <option v-for="(val,keyVal) in tag.values" :value="val.id" :key="val.id">
                                                        {{ constructLabelByKey(key,val) }}
                                                    </option>
                                                </select>
                                            </FormElement>
                                                
                                        </FormControl>
                                        
                                        <FormControl v-can="'beepiz-select-devices'">
                                            <FormLabel class="sr-only">
                                                {{ $t('profile.form.assocDevices') }}
                                                <span class="badge ml-1">{{ nbDatis }}</span>
                                            </FormLabel>
                                            <FormElement class="w-100">
                                                <div v-if="!allDatis" class="spinner-border text-secondary" role="status">
                                                    <span class="sr-only">{{ $t('global.loading') }}</span>
                                                </div>
                                                <SelectList
                                                    v-if="allDatis"
                                                    :list="allDatis"
                                                    itemType="dati"
                                                />
                                            </FormElement>
                                        </FormControl>
                                    </FormWrapper>
                                </div>
                            </UiTab>
                            <UiTab :title="$t('profile.form.tab_watchs')">
                                <div class="container-fluid">
                                    <div class="alert alert-info mb-4" v-html="$t('watches.helper_text')"></div>
                                    <WatchesForm 
                                        v-model="profileDef.watch"
                                        :datisLicences="datisLicences"
                                    />
                                </div>
                            </UiTab>
                            <UiTab :title="$t('profile.form.tab_alerts')">
                                <div class="container">
                                    <FilterField @filter="onFilter" class="mb-5" />
                                    <Config :config="profileDef.config" :filterStr="filterStr" />
                                </div>
                            </UiTab>
                        </UiTabs>
                    </UiCard>
                </div>
            </div>
        </div>
        <Toolbar>
            <Btn
                class="primary pull-right" 
                @click.native.prevent="postData()"
                :disabled="$v.$invalid || !profileDef.userCanUpdate"
                 v-can="'beepiz-edit-profiles'">
                {{ $t('global.save') }}
            </Btn>
            <Btn :class="'pull-right'" v-can="'profiles.profiles.edit'">
                <router-link to="/configurations/profiles" tag="span">{{ $t('global.cancel') }}</router-link>
            </Btn>
        </Toolbar>
    </div>
</template>

<script>
    import Vue from 'vue';
    import axios from 'axios';
    import API from '@/services/API.js';
    import Globals from '@/services/globals.js';
    import Auth from '@/services/auth.js';
    import Multiselect from '@/components/ui/Multiselect'

    import Titlebar from "@/components/ui/Titlebar";
    import Toolbar from "@/components/ui/Toolbar";
    import Btn from "@/components/ui/Button";
    import UiSwitch from "@/components/ui/Switch";
    import IconPicker from "@/components/ui/fields/IconPicker";
    import SelectList from "@/components/ui/fields/SelectList";
    import FilterField from '@/components/ui/Filter';
    import UiCard from '@/components/ui/Card';
    import OfferIcon from '@/components/offer/OfferIcon.vue';
    import UiInput from '@/components/ui/forms/UiInput';
    import FormUtils from '@/services/form.js';
    import Config from '@/views/profiles/Config';
    import Utils from "@/services/utils.js";
    import moment from 'moment';
    import 'moment-timezone';
    import pickBy from 'lodash/pickBy';
    import _find from 'lodash/find';
    import forIn from 'lodash/forIn'
    import { UiTabs, UiTab } from '@/components/ui/ui-tabs';
    import { FormLabel, FormWrapper, FormElement, FormControl, FormError } from '@/components/ui/forms';
    import UiTextarea from '@/components/ui/forms/Textarea';
    import WatchesForm from '@/components/watches/WatchesForm';

    import ProfilesIndicator from '@/components/profiles/ProfilesIndicator';
    import { required } from 'vuelidate/lib/validators'
    import {useDvFlagAccess} from "../../services/featureFlag";

    export default {
        name: 'ProfilesForm',
        components: {
            Titlebar,
            Toolbar,
            Btn,
            IconPicker,
            SelectList,
            Multiselect,
            FilterField,
            Config,
            UiTabs,
            UiTab,
            UiSwitch,
            FormLabel,
            FormWrapper,
            FormElement,
            FormControl,
            FormError,
            UiInput,
            UiTextarea,
            WatchesForm,
            ProfilesIndicator,
            OfferIcon,
            UiCard,
        },
        computed: {
            getExistingProfileName: function () {
                if (this.existingProfile !== false) {
                    return this.existingProfile.meta.name;
                }
                return '';
            },

            pageTitle: function () {
                if (this.$route.params.id && this.$route.meta.specialAction == null) {
                    if (this.profileDef.meta) {
                        return '<i class="fa ' + this.profileDef.meta.icon + '"></i> ' + this.profileDef.meta.name;
                    }
                    return '';
                } else {
                    return Utils.t('profile.titles.new');
                }
            },

            servers: function () {
                var newArray = pickBy(this.profileDef.config, function (obj, key) {
                    if (obj.server_only == null || obj.server_only == 0 || obj.server_only === undefined) {
                        return false;
                    } else {
                        return true;
                    }
                });
                return newArray;
            },

            nbDatis: function () {
                return this.profileDef.datis.length || 0;
            },

            nbAppliedDevices: function () {
                var nbSelected = 0;
                if (this.devicesList != null) {
                    for (var childIndex in this.profileDef.datis) {
                        if (this.profileDef.datis[childIndex].children == null && (this.profileDef.datis[childIndex].disabled)) {
                            nbSelected++;
                        }
                        if (this.profileDef.datis[childIndex].children && this.profileDef.datis[childIndex].children.length > 0) {
                            var temp = this.profileDef.datis[childIndex].children;
                            for (var childIndex2 in temp) {
                                if (temp[childIndex2].disabled) {
                                    nbSelected++;
                                }
                            }
                        }
                    }
                    return nbSelected;
                }
                return '';
            },

            isEditRoute(){
                if(this.$route.name === 'ProfilesShow'){
                    return true
                }
                return false
            }
        },
        data: () => ({
            filterStr: '',
            description: '',
            devicesPictures: [],
            showErrors: {
                'meta.name': false
            },
            showWarningBeepizRemoteMonitoring: false,
            existingProfile: false,
            profiles: [],
            profileIsDefault: false,
            allDatis: null,
            profileDef: {
                config: {},
                datis: [],
                meta: {
                    name: "",
                    description: "",
                    default: 0,
                    hash: "",
                    icon: ''
                },
                profileId: null,
                watch: {
                    default: {
                        email: [],
                        sms: [],
                        tts: []
                    },
                    shifts: [],
                    shifts_active: false,
                    timezone: moment.tz.guess()
                },
                userCanUpdate: true
            },
            countDatis: 0,
            datisLicences: {},
            profileDefOrigin: {},
            devicesList: [],
            tabOffersFromProfileItems: [],
            perf: null
        }),
        validations: {
            profileDef: {
                meta: {
                    name: {
                        required
                    },
                },
            },
        },
        methods: {
            userHasOffer: function (itemOffer) {

                for(var oKey in Auth.offers){
                    var offer = Auth.offers[oKey];
                    if(itemOffer.indexOf(offer) != -1){
                        return true;
                    }
                }
                return false;
            },
            constructLabelByKey: function(key,obj, keyVal){
                if(key == 'telesurveilleur'){
                    if(obj.country != null){
                        return obj.country.name + ' - ' + obj.name;
                    }

                }
                return obj.name;

            },
            selectIcon: function (icon) {
                this.profileDef.meta.icon = icon;
            },
            postData: function () {
                    
                window.Vfc.$refs.loading.show();
                const profileData = { 
                    ...this.profileDef,
                    config: Utils.getFlatConfig(this.profileDef.config),
                }

                if (this.$route.params.id == null || this.$route.meta.specialAction === 'copy') {
                    delete profileData.profileId
                    delete profileData.meta.id
                    delete profileData.meta.tracking_id
                }

                axios.post(API.endpoints.profiles.addOrEdit, profileData)
                    .then(response => {
                        if (response.status == 201 || response.status == 202) {
                            if (response.status == 202) {
                                window.Vfc.$refs.messages.sendMessage('error', Utils.t('device.noNotificationError'));
                            }
                            if (response.data.message != this.profileDef.profileId) {
                                window.V._router.replace('/configurations/profiles/' + response.data.message, () => {
                                    this.loadData();
                                });
                            }
                        }
                            
                        if (response.status === 200) {
                            window.Vfc.$refs.messages.sendMessage('success', Utils.t('global.dataSaved'));
                            this.$router.push({
                                name: "ProfilesShow",
                                params: { id: response.data.meta.id },
                            });
                        }
                    })
                    .catch(error => {
                        var errorBag = this.$validator.errorBag;
                        if (error.response.status == 422) {
                            FormUtils.handleErrors(errorBag, error.response.data.message);
                            this.handleNetworkError(error.response.data.message);
                        }
                        FormUtils.showAllErrors(this);
                        window.Vfc.$refs.loading.hide();
                    });

            },
            showAllErrors: function () {
                for (var showError in this.showErrors) {
                    this.showErrors[showError] = true;
                }
            },
            hideError: function (key) {
                this.showErrors[key] = false;
            },
            addItem(newTag, itemTagId) {
                if(newTag != ''){
                    var tag = null;

                    if(Utils.isValidEmail(newTag)){
                        tag = {
                            key: newTag,
                            label: newTag
                        }
                    }
                    else {
                        if(Utils.isValidPhoneNumber(newTag)){
                            var phone = Utils.phoneTransformer(newTag);
                            tag =  {
                                key: phone,
                                label: phone
                            }
                        }
                        else{
                            window.Vfc.$refs.messages.sendMessage('error', Utils.t('device.registrations.errors.invalidPhoneFormat'));
                        }
                    }

                    if(tag != null){
                        this.profileDef.config[itemTagId].value.push(tag)
                    }

                }

            },
            handleBlur: function(number,itemTagId){
                if(number != ''){
                    this.addItem(number,itemTagId);
                }
            },
            onFilter: function (value) {
                this.filterStr = Utils.sanitize(value);
            },
            loadData: function () {

                window.Vfc.$refs.loading.show();

                var profileId = this.$route.params.id || 'default';
                
                axios.get(API.route(API.endpoints.profiles.show, {profileId: profileId}))
                    .then( ({ data }) => {
                        this.tabOffersFromProfileItems = [];
                        this.profileDef = { ...data };

                        for (var key in this.profileDef.config) {
                            var obj = this.profileDef.config[key];
                            if (obj.created_at != null) {
                                if (moment().diff(moment(obj.created_at), 'days') < Globals.durationNewProfileItemInDays) {
                                    obj.new = true;
                                }
                            }
                            var isAlert = obj?.alert != null || key === 'lostcom' ;
                            let isPreAlert = obj.prealert_auth != null;
                            if (isAlert) {
                                obj.description = Utils.t('profile.alerts.' + key);
                            }
                            else {
                                if (!isPreAlert && obj.offers?.length < Globals.allOffers?.length) {
                                    
                                    for (var oKey in obj.offers) {
                                        if (Auth.offers.indexOf(obj.offers[oKey]) != -1) {
                                            this.tabOffersFromProfileItems.push(obj.offers.sort(Utils.compareNombres).join());
                                            break;
                                        }
                                    }
                                }
                            }
                            if (obj.type == 'array') {
                                if (obj.value == null || obj.value == "") {
                                    obj.value = [];
                                }
                                else {
                                    var vals = obj.value.split(',');
                                    obj.value = [];
                                    for (var valKey in vals) {
                                        var objToPush = {};
                                        objToPush = {key:vals[valKey],label:vals[valKey]};
                                        this.profileDef.config[key].value.push(objToPush)
                                    }
                                }
                            }

                        }

                        var tempOffers = [];
                        for (var iKey in this.tabOffersFromProfileItems) {
                            if (tempOffers.indexOf(this.tabOffersFromProfileItems[iKey]) == -1) {
                                tempOffers.push(this.tabOffersFromProfileItems[iKey]);
                            }
                        }
                        this.tabOffersFromProfileItems = tempOffers;

                        if (profileId == 'default') {
                            this.profileDef.meta.default = 0;
                            this.profileDef.meta.name = '';
                            this.profileDef.meta.description = '';
                            this.profileDef.meta.hash = '';
                            this.profileDef.meta.icon = '';
                            this.profileDef.profileId = null;
                        }
                        else {
                            if (this.$route.meta.specialAction === 'copy') {
                                this.profileIsDefault = false;
                                this.profileDef.meta.default = 0;
                            }
                            else {
                                this.profileIsDefault = this.profileDef.meta.default;
                            }
                        }

                        this.profileDef.config = forIn(this.profileDef.config,(value,key) => {
                            this.profileDef.config[key].key = key
                        })

                        this.profileDefOrigin = JSON.parse(JSON.stringify(this.profileDef));
                        if (this.$route.meta.specialAction === 'copy') {
                            this.profileDef.meta.name = this.profileDef.meta.name + ' (Copie)';
                            this.profileDef.userCanUpdate = true;
                        }
                        this.loadProfiles();

                        if (!!this.profileDef.profileId) {
                            axios.get(API.route(API.endpoints.profiles.kpi, {profileId: profileId}))
                                .then( ({ data }) => {
                                    this.perf = { ...data } 
                                })
                        }
                    })
            },
            loadProfiles: function () {
                axios.get(API.endpoints.profiles.index + API.constructQueryParams({perpage: 9999999999999}))
                    .then( ({ data }) => {
                        for (var i = 0; i < data.data.length; i++) {
                            if (data.data[i].profileId == parseInt(this.$route.params.id)) {
                                data.data.splice(i, 1);
                            }
                        }
                        this.profiles = data.data;
                        this.loadDevices();
                    })
            },
            loadDevices: function () {
                window.Vfc.$refs.loading.hide();

                axios.get(API.endpoints.datis.indexByGroup + API.constructQueryParams({perpage: 9999999999999}))
                    .then( ({ data }) => {

                        const allDatis = [...data];
                        for (var key in allDatis) {

                            var dati = allDatis[key];
                            if(dati.children != null){
                                for(var ckey in dati.children){
                                    var datiC = dati.children[ckey];

                                    Vue.util.defineReactive(datiC, 'selected', false);
                                    if (datiC.profile && this.$route.meta.specialAction !== 'copy') {
                                        if (datiC.profile.id == this.profileDef.profileId) {
                                            datiC.disabled = true;
                                            datiC.selected = true;
                                        }
                                    }

                                    datiC.warning = false;
                                    for (var oKey in this.tabOffersFromProfileItems) {
                                        var temp = this.tabOffersFromProfileItems[oKey].split(',');
                                        if (temp.indexOf(datiC.offer) == -1) {
                                            datiC.warning = true;
                                        }
                                    }
                                }
                            } else {
                                Vue.util.defineReactive(dati, 'selected', false);
                                if (dati.profile && this.$route.meta.specialAction !== 'copy') {
                                    if (dati.profile.id == this.profileDef.profileId) {
                                        dati.disabled = true;
                                        dati.selected = true;
                                    }
                                }
                                dati.warning = false;
                                for (var oKey in this.tabOffersFromProfileItems) {
                                    var temp = this.tabOffersFromProfileItems[oKey].split(',');
                                    if (temp.indexOf(dati.offer) == -1) {
                                        dati.warning = true;
                                    }
                                }
                            }
                        }
                        this.profileDefOrigin.datis = JSON.parse(JSON.stringify(allDatis));
                        if (this.$route.query.dati != null) {
                            for (var key in allDatis) {
                                var dati = allDatis[key];
                                if(dati.children != null){
                                    for (var ckey in dati.children) {
                                        var datiC = dati.children[ckey];
                                        if (datiC.id == this.$route.query.dati) {
                                            datiC.selected = true;
                                        }
                                    }
                                } else {
                                    if (dati.id == this.$route.query.dati) {
                                        dati.selected = true;
                                    }
                                }
                            }
                        }

                        if (this.isEditRoute && this.$route.params.id && this.nbAppliedDevices < this.countDatis) {
                            window.Vfc.$refs.confirm.show({
                                title: Utils.t('global.warningModalTitle'),
                                type: 'warning',
                                content: Utils.t('profile.warningVisibility',{count:(this.countDatis - this.nbAppliedDevices)})+'<br><br>'+Utils.t('profile.warningVisibility2'),
                                callbackYes: () => {

                                },
                                callbackNo: () => {
                                    window.V._router.go(-1);
                                }
                            });
                        }

                        this.allDatis = [...allDatis];

                        window.Vfc.$refs.loading.hide();
                    })
            },
            handleDefaultStar: function () {
                if (this.profileIsDefault == false) {
                    this.profileDef.meta.default = !this.profileDef.meta.default;
                }
            },
            hasUserValidOffer: function (item) {
                if (Utils.intersectwith(Utils.equals, Auth.offers, [item.offer]).length > 0) {
                    return true;
                }
                return false;
            },
            handleNetworkError: function (message) {
                if (window.V.$i18n.te(`profile.errors.${message}`)) {
                    window.Vfc.$refs.messages.sendMessage('error', window.V.$i18n.t(`profile.errors.${message}`));
                } else {
                    window.Vfc.$refs.messages.sendMessage('error', window.V.$i18n.t(`profile.errors.default`));
                }
            }
        },
        mounted() {
          if (!useDvFlagAccess("beepiz-profile-can:create")) {
            this.$router.push({ name: 'AccessDenied', params: { slug: 'licences'} })
          }
            this.loadData();
        },
        watch: {
            allDatis: {
                handler(newValue) {
                    const selectedDatis = []
                    const selectedDatisLicences = {}
                    newValue.forEach(dati => {
                        if ( dati.children != null ) {
                            dati.children.forEach(childDati => {
                                if ( childDati.selected || childDati.disabled ) {
                                    selectedDatis.push(childDati.id);
                                    selectedDatisLicences[childDati.offer] = (selectedDatisLicences[childDati.offer] || 0) + 1;
                                }
                            })
                        } else {
                            if ( dati.selected || dati.disabled) {
                                selectedDatis.push(dati.id);
                                selectedDatisLicences[dati.offer] = (selectedDatisLicences[dati.offer] || 0) + 1;
                            }
                        }
                    })
                    this.profileDef.datis = [ ...selectedDatis ];
                    this.datisLicences = { ...selectedDatisLicences };
                },
                deep: true
            },
        }
    }
</script>

<style lang="scss">

.star-check {
    cursor: pointer;
    display: block;
    font-size: var(--input-height);
    position: relative;
    width: var(--input-height);
    height: var(--input-height);
    text-align: center;

    .fa-star-o,
    .fa-star,
    .focus-block {
        position: absolute;
        inset: 0;
        line-height: var(--input-height);
        color: var(--colors-gray-300);  
    }

    .fa-star {
        opacity: 0;
        color: var(--input-border-color);
    }

    input {
        opacity: 0;
    }
    input:checked ~ .fa-star {
        opacity: 1;
    }
    input:focus-visible ~ .focus-block {
        box-shadow: var(--button-focus-shadow);
        border-radius: var(--input-radius);
    }
}

</style>
